import { render, staticRenderFns } from "./string_nolang.vue?vue&type=template&id=680c6ae4"
import script from "./string_nolang.vue?vue&type=script&lang=js"
export * from "./string_nolang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports